import ym from 'react-yandex-metrika';

const isProd = process.env.NODE_ENV === 'production';

export const notificationClickTrack = () => {
  return isProd && ym('reachGoal', 'notifications');
};

export const applicationOpenTrack = () => {
  return isProd && ym('reachGoal', 'rashlop');
};

export const dealerFilterTrack = () => {
  return isProd && ym('reachGoal', 'search_dc');
};

export const ksoFilterTrack = () => {
  return isProd && ym('reachGoal', 'search_kso');
};

export const mopFilterTrack = () => {
  return isProd && ym('reachGoal', 'search_mop');
};

export const phoneClickTrack = () => {
  return isProd && ym('reachGoal', 'telephone_rashlop');
};

export const searchTrack = () => {
  return isProd && ym('reachGoal', 'search_application');
};

export const certificateClickTrack = () => {
  return isProd && ym('reachGoal', 'certificate');
};

export const sendClickTrack = () => {
  return isProd && ym('reachGoal', 'send_rashlop');
};

export const lostClickTrack = () => {
  return isProd && ym('reachGoal', 'lost_applications');
};

export const tabListOpenTrack = () => {
  return isProd && ym('reachGoal', 'tab_list_applications');
};

export const applicationRowOpenButtonTrack = () => {
  return isProd && ym('reachGoal', 'open');
};

//fast buttons
export const actionMenucalCalculatorButtonTrack = () => {
  return isProd && ym('reachGoal', 'Быстрые кнопки. Список заявок. Рассчитать кредит');
};

export const actionMenucalAnketaButtonTrack = () => {
  return isProd && ym('reachGoal', 'Быстрые кнопки. Открыть анкету и документы');
};

export const actionMenucalThirdTabButtonTrack = () => {
  return isProd && ym('reachGoal', 'Быстрые кнопки. Перейти к рассмотрению заявки');
};

export const dealActionFinanceButtonTrack = () => {
  return isProd && ym('reachGoal', 'Расхлоп. Профинансировать и закрыть');
};

export const dealActionCreateLoanIssueButtonTrack = () => {
  return isProd && ym('reachGoal', 'Расхлоп. Оформить цифровую сделку');
};

export const dealActionEnterFinalParamsBackButtonTrack = () => {
  return isProd && ym('reachGoal', 'Расхлоп. Возврат к итоговой');
};

export const actionMenuCreditRefusalButtonTrack = () => {
  return isProd && ym('reachGoal', 'Быстрые кнопки. Поставить отказ от кредита');
};
